import { FC } from 'react'
import { useParams } from 'react-router-dom'
import classes from './classes.module.scss'
import Tooltip from 'components/organisms/Tooltip/Tooltip'
import TranslationMemoryDetails from 'components/organisms/TranslationMemoryDetails/TranslationMemoryDetails'
import TranslationMemorySubProjectsTable from 'components/organisms/tables/TranslationMemorySubProjectsTable/TranslationMemorySubProjectsTable'
import { useFetchTranslationMemory } from 'hooks/requests/useTranslationMemories'
import { useAuth } from 'components/contexts/AuthContext'
import Loader from 'components/atoms/Loader/Loader'
import { includes } from 'lodash'
import { Privileges } from 'types/privileges'
import TranslationMemoryContentChecksTable from 'components/organisms/tables/TranslationMemoryContentChecksTable copy/TranslationMemoryContentChecksTable'

const TranslationMemoryPage: FC = () => {
  const { memoryId = '' } = useParams()
  const { userInfo, userPrivileges } = useAuth()
  const { selectedInstitution } = userInfo?.tolkevarav || {}
  const { translationMemory, isLoading, chunk_amount, edit_url } = useFetchTranslationMemory({
    id: memoryId,
  })

  const isTmOwnedByUserInstitution =
    selectedInstitution?.id === translationMemory?.tenant_id

  if (isLoading) return <Loader loading={isLoading} />

  return (
    <>
      <div className={classes.titleRow}>
        <h1>{translationMemory?.name}</h1>
        <Tooltip helpSectionKey="translationMemory" />
      </div>
      <TranslationMemoryDetails
        translationMemory={{
          ...translationMemory,
          chunk_amount,
          edit_url,
        }}
        memoryId={memoryId}
        isTmOwnedByUserInstitution={isTmOwnedByUserInstitution}
      />
      <TranslationMemoryContentChecksTable
        memoryId={memoryId}
        hidden={!isTmOwnedByUserInstitution}
      />
      <TranslationMemorySubProjectsTable
        memoryId={memoryId}
        hidden={
          !isTmOwnedByUserInstitution ||
          !includes(userPrivileges, Privileges.ViewInstitutionProjectList)
        }
      />
    </>
  )
}

export default TranslationMemoryPage
